import { calculateRoundedValue } from './index';
import { messageParser } from '../constants/msgParserUtils';

/**
 * Export order groups to Excel with custom format
 * @param {Array} orderGroupDownload - Array of order groups to export
 * @param {Object} rateData - Exchange rate data containing baht and usd rates
 * @param {Function} addToast - Toast notification function
 */
export const exportToExcelNewFormat = (orderGroupDownload, rateData, addToast) => {
  if (orderGroupDownload.length <= 0) {
    addToast("ກະລຸນາເລືອກອໍເດີ້ໃດຫນຶ່ງກ່ອນ!", {
      appearance: "warning",
      autoDismiss: true,
    });
    return;
  }

  // Find the maximum number of products in any order group
  const maxProducts = Math.max(...orderGroupDownload.map(orderGroup => 
    orderGroup.orders ? orderGroup.orders.length : 0
  ));

  // Create header row
  const headers = [
    'ຊື່', 'ເບີໂທ', 'ຂົນສົ່ງ', 'ສາຂາ', 'ລວມເງີນ', 'ສະຖານະ'
  ];

  // Add dynamic product headers
  for (let i = 1; i <= maxProducts; i++) {
    headers.push(`ສີ້ນຄ້າ${i}`, `ລາຄາ${i}`, `Size${i}`);
  }

  const parser = new messageParser();

  // Create data rows
  const rows = orderGroupDownload.map(orderGroup => {
    const result = parser.parseDeliveryService(orderGroup?.logistic || orderGroup?.addressCf || "");
    
    // Calculate comprehensive total price like in OrderGroupDetail.js
    const calculateTotalPrice = (orderGroup) => {
      const kip = parseFloat(orderGroup?.totalPrice || 0);
      const rateBath = rateData?.baht || 0;
      const rateUsd = rateData?.usd || 0;
      const baht = parseFloat(orderGroup?.sumPriceBaht || 0) * parseFloat(rateBath || 0);
      const usd = parseFloat(orderGroup?.sumPriceUsd || 0) * parseFloat(rateUsd || 0);

      let sumPrice = parseFloat(kip + baht + usd).toFixed(2);
      if (sumPrice < parseFloat(orderGroup?.sumPrice || 0)) {
        sumPrice = parseFloat(orderGroup?.sumPrice || 0);
      }
      return calculateRoundedValue(sumPrice / 1000) * 1000;
    };

    const totalPrice = calculateTotalPrice(orderGroup);
    
    const row = [
      orderGroup?.customerName || orderGroup?.cfName || '-',
      orderGroup?.phone || '-',
      result?.delivery_service || orderGroup.logistic || orderGroup?.addressCf || '-',
      orderGroup?.addressCf || orderGroup.logistic || '-',
      new Intl.NumberFormat("en-US").format(totalPrice),
      orderGroup?.isPaymented ? "ຈ່າຍແລ້ວ" : "ຍັງບໍ່ຈ່າຍ"
    ];

    // Add product data
    const orders = orderGroup.orders || [];
    for (let i = 0; i < maxProducts; i++) {
      if (i < orders.length) {
        const order = orders[i];
        row.push(
          order.productName || '-',
          new Intl.NumberFormat("en-US").format(order?.price * order?.amount || 0),
          order?.stock?.optionValues?.map((item) => item?.value)?.join(',') || '-'
        );
      } else {
        row.push('-', '-', '-');
      }
    }

    return row;
  });

  // Create CSV content
  const csvContent = [headers, ...rows]
    .map(row => row.map(cell => `"${cell}"`).join(','))
    .join('\n');

  // Create and download file
  const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `order_custom_format_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};